export default {
  heatingSection: {
    title: {
      fr: "Pilotez le chaud et le froid.",
      en: "Control heating and cooling.",
    },
    subtitle: {
      fr: "",
      en: "",
    },
    features: {
      title: {
        fr: "Un confort thermique pour tout type de chauffage.",
        en: "Thermal comfort for every type of heating system.",
      },
      items: {
        electricalRadiator: {
          title: {
            fr: "Radiateur électrique fil pilote",
            en: "Wire pilot electric radiators",
          },
          description: {
            fr: "Compatible 4 et 6 ordres.",
            en: "Compatible with 4- and 6-order control systems.",
          },
        },
        radiatorValve: {
          title: {
            fr: "Tête thermostatique",
            en: "Thermostatic valve",
          },
          description: {
            fr: "Compatible avec les têtes thermostatique Zigbee du marché.",
            en: "Compatible with most Zigbee thermostatic valves on the market.",
          },
        },
        acSplit: {
          title: {
            fr: "Climatisation réversible",
            en: "Reversible air conditioning",
          },
          description: {
            fr: "Fonctionne avec Airzone Aidoo.",
            en: "Works seamlessly with Airzone Aidoo.",
          },
        },
      },
    },
  },
};
